class NavDrawerBanner extends HTMLElement {
    connectedCallback() {
        this.config = JSON.parse(this.dataset.config || '{}');


        if (typeof window.Swiper != 'undefined') {
            new Swiper(this, {
                ...this.config,
                spaceBetween: 12,
                pagination: {
                   el: '.swiper-pagination',
                }
            });
        }
    }
}

customElements.define('hoculus-nav-drawer-banner', NavDrawerBanner);